import { ErrorHandler, Injectable, InjectionToken, inject } from '@angular/core';
import Rollbar from 'rollbar';
import { environment } from '../../environments/environment';

/**
 * Lives outside `app.module.ts` on purpose: `ErrorInterceptor` needs `RollbarService`, and
 * `app.module` imports the interceptor's module — importing the token from `app.module`
 * closed that cycle and crashed module init with "Cannot access 'ErrorInterceptor' before
 * initialization".
 */
const rollbarConfig = {
  accessToken: '53c5998f25754234820231131d94319b',
  captureUncaught: true,
  captureUnhandledRejections: true,
};

export const RollbarService = new InjectionToken<Rollbar>('rollbar');

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {
  private rollbar = inject<Rollbar>(RollbarService);

  handleError(err: any): void {
    if (environment.production) {
      this.rollbar.error(err.originalError || err);
    } else {
      console.error(err);
    }
  }
}

export function rollbarFactory() {
  return new Rollbar({ ...rollbarConfig, captureIp: 'anonymize', reportLevel: 'error' });
}
